import React from "react";
import Container from "react-bootstrap/Container";
import CommunityForm from "./CommunityForm";


function RegisterCommunity() {
  return (
      <Container className="px-0 pt-5">
        <div className="register-community">
          <h3 className="text-center text-uppercase mb-5">Community Registration</h3>
        </div>
        <CommunityForm formSource="page" />
      </Container>
  );
}

export default RegisterCommunity;
